import { BaseModel } from '@shared/base.model';
import { Organization } from '@shared/models/organization/organization.model';
import { Program } from './program.model';
import { ProgramPreQualification } from './program-pre-qualification.model';
import { ProgramApplicationStatus } from './program-application-status.model';
import { APPLICATION_LOCKED } from './application-locked.enum';
import { ProgramApplicationStageConfiguration } from './program-application-stage-configuration.model';
import { Evaluation } from './evaluation/evaluation.model';

export class ProgramApplication extends BaseModel<ProgramApplication> {
  approvalDateTime: Date;
  preApprovalDateTime: Date;
  denialDateTime: Date;
  deleteDate: Date;
  participant: Organization;
  program: Program;
  programPreQualifications: ProgramPreQualification[] = [];
  submitDateTime: Date;
  inReviewDateTime: Date;
  incompleteDateTime: Date;
  investorComments: string;
  adminNotes: string;
  applicationStatuses: ProgramApplicationStatus[];
  applicationLocked: APPLICATION_LOCKED;
  formioId: string;
  formSaved: boolean;

  programApplicationStageConfiguration: ProgramApplicationStageConfiguration;  //Transient
  evaluations: Evaluation[];  //Transient
  currentStatus: string;  //Transient

  constructor(programApplicationInfo) {
    super();
    this.id = programApplicationInfo.id;
    this.approvalDateTime = programApplicationInfo.approvalDateTime;
    this.preApprovalDateTime = programApplicationInfo.preApprovalDateTime;
    this.denialDateTime = programApplicationInfo.denialDateTime;
    this.deleteDate = programApplicationInfo.deleteDate;
    this.participant = new Organization(programApplicationInfo.participant || {});
    this.program = new Program(programApplicationInfo.program || {});
    this.submitDateTime = programApplicationInfo.submitDateTime;
    this.inReviewDateTime = programApplicationInfo.inReviewDateTime;
    this.incompleteDateTime = programApplicationInfo.incompleteDateTime;
    this.investorComments = programApplicationInfo.investorComments;
    this.adminNotes = programApplicationInfo.adminNotes;
    this.applicationStatuses = programApplicationInfo.applicationStatuses ?
      programApplicationInfo.applicationStatuses
      .map((status: ProgramApplicationStatus) => new ProgramApplicationStatus(status)) : null;
    if (programApplicationInfo.programPreQualifications) {
      programApplicationInfo.programPreQualifications.forEach((preQual: ProgramPreQualification) => {
        this.programPreQualifications.push(new ProgramPreQualification(preQual));
      });
    }
    this.applicationLocked = programApplicationInfo.applicationLocked;
    this.formioId = programApplicationInfo.formioId;
    this.formSaved = programApplicationInfo.formSaved;
    this.programApplicationStageConfiguration = programApplicationInfo.programApplicationStageConfiguration;
  }

  get link() {
    return `/oes/finance/programs/detail/${this.program.id}/application/${this.id}`;
  }

  get status(): string | null {
    const sorted = this.applicationStatuses.sort((a, b) => {
      return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
    });

    return sorted[0].name;
  }

  get statusWithNotSubmitted(): string {
    const sorted = this.applicationStatuses.sort((a, b) => {
      if ((a.timestamp && !b.timestamp) || (!a.timestamp && !b.timestamp)) {
        return -1;
      }
      if (!a.timestamp && b.timestamp) {
        return 1;
      }
      return (new Date(b.timestamp).valueOf() - new Date(a.timestamp).valueOf());
    });
    if (sorted[0].timestamp === null || sorted[0].timestamp === undefined) {
      return 'Not Submitted';
    }
    return sorted[0].name;
  }

  get completeStatusWithNotSubmitted(): ProgramApplicationStatus | null {
    const sorted = this.applicationStatuses.sort((a, b) => {
      if ((a.timestamp && !b.timestamp) || (!a.timestamp && !b.timestamp)) {
        return -1;
      }
      if (!a.timestamp && b.timestamp) {
        return 1;
      }
      return (new Date(b.timestamp).valueOf() - new Date(a.timestamp).valueOf());
    });
    if (sorted[0].timestamp === null || sorted[0].timestamp === undefined) {
      return null;
    }
    return sorted[0];
  }
}
